export default "__VITE_ASSET__D082o1ol__"